import Navigation from '../components/Navigation'
import Header from '../components/Header'
import Journey from '../components/Journey'
import Technology from '../components/Technology'

export const HomePage = () => { 
    return (
        <div>
            <Navigation />
            <Header />
            <Journey />
            <Technology />
        </div>
    );
}
